import { FavoriteMenuComponent } from './../portal-menu/favorite-menu/favorite-menu.component';
import { MatMenuTrigger } from '@angular/material/menu';
import { Component, EventEmitter, HostListener, OnInit, Output, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { NavigationEnd, Router } from '@angular/router';
import * as _ from 'lodash';
// @ts-ignore
import printJS from 'print-js';
import { Observable, Subscription } from 'rxjs';
import { take } from 'rxjs/operators';
import { ClassroomSummaryService } from '../../classroom360/classroom-summary/classroom-summary.service';
import { ClassroomSummary } from '../../classroom360/classroom-summary/models/classroom-summary.model';
import { Classroom360Service } from '../../classroom360/classroom360.service';
import { DataQueryService } from '../../classroom360/data-query/data-query.service';
import { SelectCourseDialogComponent } from '../../classroom360/guards/select-course/select-course-dialog/select-course-dialog.component';
import { AddLinkComponent } from '../../classroom360/links/add-link/add-link.component';
import { Link } from '../../classroom360/links/link.model';
import { ChangePasswordComponent } from '../../shared-modules/login/change-password/change-password.component';
import { LoginService } from '../../shared-modules/login/login.service';
import { LoginSettings } from '../../shared-modules/login/LoginSetting.model';
import { ReportingComponent } from '../../shared-modules/reporting/reporting.component';
import { PortalAccessDeniedComponent } from '../../student360/portal-access-denied/portal-access-denied.component';
import { Student360Service } from '../../student360/student360.service';
import { ChangeEmailComponent } from '../change-email/change-email.component';
import { AboutPanelComponent } from '../controls/about-panel/about-panel.component';
import { GeneralConfirmationComponent } from '../controls/general-confirmation/general-confirmation.component';
import { FavoritesModalComponent } from '../favorites/favorites-modal/favorites-modal.component';
import { CheckForErrorsGuard } from '../guards/check-for-errors/check-for-errors.guard';
import { SystemLog } from '../models/system-log.model';
import { Portal } from '../portal.model';
import { RouteInfo } from '../routeInfo';
import { SecurityService } from '../security/security.service';
import { SharedService } from '../shared.service';
import { SpinnerService } from '../spinner/spinner.service';
import { StudentSearchComponent } from '../student-search/student-search.component';
import { StudentSearchService } from '../student-search/student-search.service';
import { StudentInFocusComponent } from '../student/student-in-focus/student-in-focus.component';
import { Student } from '../student/student.model';
import { StudentService } from '../student/student.service';
import { System } from '../System';
import { FavoritePortal } from '../user-preferences/favorite-portals.model';
import { FavoritePreferences } from '../user-preferences/favorite-prefences.model';
import { PortalMenuItem, PortalMenuPreferences } from '../user-preferences/portal-menu-preferences.model';
import { UserPreferencesWindowComponent } from '../user-preferences/user-preferences-window/user-preferences-window.component';
import { UserPreferencesService } from '../user-preferences/user-preferences.service';
import { User } from '../user/user.model';
import { UserService } from '../user/user.service';
import { School } from '../year/school.model';
import { Year } from '../year/year.model';
import { YearService } from '../year/year.service';
import { AuthService } from '../../shared-modules/login/auth.service';
import { ReportingFrameworkService } from '../../classroom360/reporting-framework/reporting-framework.service';
import { MyReportsComponent } from '../../classroom360/reporting-framework/my-reports/my-reports.component';

// Google API Variable
declare const google: any;
@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: [
        './header.component.scss'
    ]
})
export class HeaderComponent implements OnInit {
    public parentAssignedPortals: Portal[] = [];
    public parentPortalsDeepCopy: Portal[] = []; // used to compare portals and links
    public staffAssignedPortals: Portal[] = [];
    public staffPortalMenuPreferences: PortalMenuPreferences = new PortalMenuPreferences;
    public parentAssignedFavoritePortals: Portal[] = [];
    public staffAssignedFavoritePortals: Portal[] = [];
    public staffFavoritePortalMenuPreferences: PortalMenuPreferences = new PortalMenuPreferences;
    public students: Student[];
    public selectedStudent: Student;
    public years: Year[];
    public schools: School[];
    public LoginSettings: LoginSettings;
    public currentUser: User;
    userInitials: string;
    myClasses: ClassroomSummary[];
    gradebookClasses: ClassroomSummary[];
    attendanceClasses: ClassroomSummary[];
    myLinks: Link[];
    districtLinks: Link[];
    myFavorites: FavoritePortal[];
    studentSubscription: Subscription;
    yearSubscription: Subscription;
    schoolsSubscription: Subscription;
    isLoggedIn: boolean;
    isLoggedInSubscription: Subscription;
    isPageLoaded: boolean;
    isPageLoadedSubscription: Subscription;
    parentAssignedPortalsSubscription: Subscription;
    staffAssignedPortalSubscription: Subscription;
    changeEmailDialogRef: MatDialogRef<ChangeEmailComponent>;
    ChangePasswordDialogRef: MatDialogRef<ChangePasswordComponent>;
    StudentSearchDialogRef: MatDialogRef<StudentSearchComponent>;
    favoritesDialogRef: MatDialogRef<FavoritesModalComponent>;
    aboutTylerSISDialog: MatDialogRef<AboutPanelComponent>;
    studentInFocusDialog: MatDialogRef<StudentInFocusComponent>;
    languageLinkVisible = false;
    myClassesSubscription: Subscription;
    currentUserSubscription: Subscription;
    defaultYearSubscription: Subscription;
    parentPortalsSubscription: Subscription;
    setSchoolDisabledSubscription: Subscription;
    setYearDisabledSubscription: Subscription;
    loginSettingSubscription: Subscription;
    // ------------Modal window--------------------------------------
    userPrefDialogRef: MatDialogRef<UserPreferencesWindowComponent>;
    reportsDialogRef: MatDialogRef<ReportingComponent>;
    myReportsDialogRef: MatDialogRef<MyReportsComponent>;
    addLinkDialogRef: MatDialogRef<AddLinkComponent>;
    portalAccessDeniedDialog: MatDialogRef<PortalAccessDeniedComponent>;
    gradebookAccessDeniedDialog: MatDialogRef<GeneralConfirmationComponent>;
    TylerUSettingDialog: MatDialogRef<GeneralConfirmationComponent>;
    selectedSchoolId = 0;
    selectedYear: Year;
    showSchoolDropdown = false;
    showYearDropdown = false;
    enableClassDropdown = false;
    showTeacherProfile = false;
    disableYearDropdown = false;
    hidePrintButton = false;
    screenWidth = 0;
    windowWidth = 0;
    impersonateByUserId: number;
    userLoginFromLegacy = false;
    pulseWindow;
    pulsePageList = [];
    pulseFavoriteList = [];
    favoritesShown: boolean;
    showNotificationPreferencesLink = false;
    showChangePassword = true;
    helpContextId: string;
    @Output() toggleEvent = new EventEmitter();
    @ViewChild('favoritesMenuTrigger', { read: MatMenuTrigger }) favoritesMenuTriggerRef: MatMenuTrigger;
    schoolId = 0;
    stopImpersonating = false;
    IntegrateWithTylerU: boolean;
    @ViewChild(FavoriteMenuComponent) favoriteMenuComponent: FavoriteMenuComponent;

    // change public service to private and remove from html
    constructor(private loginService: LoginService,
        public studentService: StudentService,
        public userService: UserService,
        private yearService: YearService,
        private authService: AuthService,
        private classroomSummaryService: ClassroomSummaryService,
        private student360Service: Student360Service,
        private classroom360Service: Classroom360Service,
        private userPreferencesService: UserPreferencesService,
        private sharedService: SharedService,
        private router: Router,
        private dialog: MatDialog,
        private guard: CheckForErrorsGuard,
        private dataQueryService: DataQueryService,
        private spinnerService: SpinnerService,
        private securityService: SecurityService,
        private studentSearchService: StudentSearchService,
        private reportingFrameworkService: ReportingFrameworkService
    ) {
    }

    toggleClick() {
        this.toggleEvent.emit();
    }

    ngOnInit() {
        this.LoginSettings = this.loginService.LoginSettings;
        this.loginService.IntegrateWithTylerU = this.loginService.LoginSettings.IntegrateWithTylerU;
        this.IntegrateWithTylerU = this.loginService.LoginSettings.IntegrateWithTylerU;
        this.currentUserSubscription = this.userService.observableCurrentUserStream$
            .subscribe(data => {
                this.currentUser = data;
                this.userInitials = this.currentUser.FirstName.substring(0, 1).toUpperCase() + this.currentUser.LastName.substring(0, 1).toUpperCase();
                this.getUserLoginFromLegacy();

                if (this.LoginSettings.EnablePulseSSO && this.currentUser.UserType == 1) {
                    this.getPulseList();
                }

                if (this.currentUser.UserType == 2) {
                    this.userService.setNotificationPreferencesMenu().subscribe(result => {
                        this.showNotificationPreferencesLink = result;
                    });
                }

                this.getUserPermission();
            });
        this.studentSubscription = this.studentService.observableStudentsStream$
            .subscribe(data => {
                this.students = data;
            });
        this.parentAssignedPortalsSubscription = this.student360Service.observableParentAssignedPortalsStream$
            .subscribe(data => {
                this.parentPortalsDeepCopy = _.cloneDeep(data);
                this.parentAssignedPortals = data.filter(a => a.ShowAsMenu);
                if (this.router.url.toLowerCase().indexOf('/student360') >= 0) {
                    let portalURL = this.router.url.toLowerCase().replace('/student360', '');
                    if (portalURL.includes('?')) {
                        portalURL = portalURL.substring(0, portalURL.indexOf('?'));
                    }
                    const parentAssignedPortal = this.parentAssignedPortals.filter(a => a.PortalDescription.toLowerCase() == portalURL && a.Disabled == true)[0];
                    if (parentAssignedPortal != null && portalURL != undefined && portalURL != '/onlineregistration') {
                        this.router.navigateByUrl('/student360/studentSummary');
                    }
                }
            });
        this.yearSubscription = this.yearService.observableYearStream$
            .subscribe(yearList => {
                const years: Year[] = _.cloneDeep(yearList);
                if (this.userService.currentUser.UserType == 1 && this.studentService.selectedStudent) {
                    const yearsValue = years.filter(year => year.SchoolID == 0);
                    if (yearsValue.length == 0) {
                        let school = this.yearService.defaultYear.SchoolID == 0 ? this.schoolId : this.yearService.defaultYear.SchoolID;
                        school = school == 0 ? this.userService.currentUser.LoginSchoolId : school;
                        this.years = years.filter(year => year.SchoolID == school);
                        if (this.years.length == 0) {
                            this.years = years.filter(year => year.SchoolID == 0);
                        }
                        this.schools = _.sortBy(this.yearService.schoolsForC360, ['SchoolCode', 'SchoolName']);

                        if (this.yearService.defaultYear) {
                            this.selectedYear = this.years.filter(o => o.Id == this.yearService.defaultYear.Id)[0];
                            this.selectedSchoolId = school;
                        }
                    } else {
                        let school = this.yearService.defaultYear.SchoolID == 0 ? this.schoolId : this.yearService.defaultYear.SchoolID;
                        school = school == 0 ? this.userService.currentUser.LoginSchoolId : school;
                        this.years = years.filter(year => year.SchoolID == school);
                        if (this.years.length == 0) {
                            this.years = years.filter(year => year.SchoolID == 0);
                        }
                        if (this.yearService.defaultYear) {
                            this.selectedYear = this.years.filter(o => o.Id == this.yearService.defaultYear.Id)[0];
                            this.selectedSchoolId = school;
                        }
                    }
                }
                this.years = [];
                years.forEach(obj => {
                    if (this.years.filter(o => o.Id == obj.Id).length == 0) {
                        this.years.push(obj);
                    }
                });
                this.schools = _.sortBy(this.yearService.schools, ['SchoolCode', 'SchoolName']);
                if (this.schools.filter(x => x.Id == 0).length > 0) {
                    this.schools = _.sortBy(this.yearService.schoolsForC360, ['SchoolCode', 'SchoolName']);
                    this.yearService.schools = this.yearService.schoolsForC360;
                }

                if (this.yearService.defaultYear) {
                    this.selectedYear = this.years.filter(o => o.Id == this.yearService.defaultYear.Id)[0];
                    this.selectedSchoolId = this.yearService.defaultYear.SchoolID;
                }
                this.getSelectedSchoolYearStatus();
            });
        this.schoolsSubscription = this.yearService.observableSchoolsStream$.subscribe(schools => {
            if (schools) {
                this.schools = _.sortBy(schools, ['SchoolCode', 'SchoolName']);
                if (this.schools.filter(x => x.Id == 0).length > 0) {
                    this.schools = _.sortBy(this.yearService.schoolsForC360, ['SchoolCode', 'SchoolName']);
                    this.yearService.schools = this.yearService.schoolsForC360;
                }

                if (this.yearService.defaultYear && this.years) {
                    this.selectedYear = this.years.filter(o => o.Id == this.yearService.defaultYear.Id)[0];
                    this.selectedSchoolId = this.yearService.defaultYear.SchoolID;
                    this.getSelectedSchoolYearStatus();
                }
            }
        });
        this.isLoggedInSubscription = this.userService.isLoggedInStream$
            .subscribe(data => {
                this.isLoggedIn = data;
            });
        this.staffAssignedPortalSubscription = this.classroom360Service.observableStaffAssignedPortalsStream$
            .subscribe(data => {
                this.staffAssignedPortals = data.filter(a => a.ShowAsMenu);
                this.showTeacherProfile = data.filter(o => o.PortalDescription == '/teacherProfile' && o.Disabled == false && o.Deleted == false).length > 0;
            });
        this.isPageLoadedSubscription = this.sharedService.observableIsPageLoadedStream$
            .subscribe(data => {
                this.isPageLoaded = data;
            });
        this.myClassesSubscription = this.classroomSummaryService.observableMyClassesStream$.subscribe(data => {
            if (data && this.currentUser != undefined) {
                data.forEach(course => course.CourseMenuText = this.classroomSummaryService.getCourseSummary(course));
                this.myClasses = data;
            }
        });
        this.router.events.subscribe((event) => {
            if (event instanceof NavigationEnd) {
                this.getPageInfo(this.router.url);
                if (this.router.url == '/classroom360/classroomAttendance') {
                    this.getAttendanceClasses();
                } else if (this.router.url == '/classroom360/gradebook/V9') {
                    this.getGradebookClasses();
                }
                // Clear Access Token After Logout
                else if (this.router.url == '/login' && sessionStorage.getItem('accessToken')) {
                    this.studentService.selectedStudent = undefined;
                    if (sessionStorage.getItem('loginFromLegacy') != null || sessionStorage.getItem('loginFromLegacy') == '1') {
                        sessionStorage.removeItem('accessToken');
                        window.close();
                    }
                }
                if (this.sharedService.currentUrl != this.sharedService.previousUrl) {
                    const studentId = this.selectedStudent != undefined ? this.selectedStudent.Id : 0;
                    const schoolId = this.yearService.defaultYear != undefined ? this.yearService.defaultYear.SchoolID : 0;
                    const yearId = this.yearService.defaultYear != undefined ? this.yearService.defaultYear.Id : 0;
                    let pageUrl = this.router.url;
                    if (pageUrl.indexOf('onlinePayment') > 0) {
                        pageUrl = '/student360/onlinePayment';
                    }
                    this.sharedService.saveWebPageAudit(studentId, schoolId, yearId, pageUrl).subscribe();
                }
                if (this.router.url == '/logout') {
                    // Logging out - clear the session storage here
                    sessionStorage.removeItem('accessToken');
                    sessionStorage.removeItem('impersonateUseraccessToken');

                    setTimeout(() => {
                        location.reload();
                    }, 0);
                }
                // clear stored custom field data on route change
                this.sharedService.observableClearStoredCustomFieldData.next();
            }
        });

        this.defaultYearSubscription = this.yearService.observableDefaultYearStream$.subscribe((defaultYear) => {
            if (this.currentUser && this.currentUser.UserType == 1) {
                // Set Teacher Status based on school/year when not already on Classroom Summary
                if (this.router.url.indexOf('classroomSummary') == -1) {
                    this.userService.getUserIsTeacher(this.yearService.defaultYear.SchoolID, this.yearService.defaultYear.Id).subscribe(result => {
                        this.userService.currentUser.UserIsTeacher = result;
                    });
                }

                if (this.yearService.allYears) {
                    this.schools = this.yearService.getSchoolsForSelectedYear(this.yearService.allYears, this.yearService.defaultYear);
                    this.schools = _.sortBy(this.schools, ['SchoolCode', 'SchoolName']);
                    this.selectedYear = this.yearService.defaultYear;
                    this.selectedSchoolId = this.selectedYear.SchoolID;
                    this.getSelectedSchoolYearStatus();
                }
            }
        });

        this.parentPortalsSubscription = this.student360Service.observableParentAssignedPortalsStream$.subscribe(() => {
            if (this.studentService.selectedStudent && this.router.url != '/login') {
                const studentId = this.studentService.selectedStudent.Id;
                if (this.userService.userType == 2 && this.student360Service.allParentPortals != undefined) {
                    let portalURL = this.router.url;
                    portalURL = portalURL.replace('/student360', '');
                    portalURL = (portalURL.indexOf('?') > -1) ? portalURL.substr(0, portalURL.indexOf('?')) : portalURL;
                    const parentPortal = this.student360Service.allParentPortals.filter(a => a.PortalDescription == portalURL && a.Student_ID == studentId)[0];
                    if ((portalURL != '/studentSummary' && portalURL != '/changePassword') && parentPortal == undefined) {
                        const previousPortal = this.sharedService.previousPortal;
                        this.logAccessDeniedInfo();
                        this.portalAccessDeniedDialog = this.dialog.open(PortalAccessDeniedComponent, {
                            panelClass: 'tyl-mat-dialog',
                            disableClose: true
                        });
                        this.portalAccessDeniedDialog.componentInstance.portalName = previousPortal.PortalName;
                        this.router.navigateByUrl('/student360/studentSummary');
                    }
                } else if (this.userService.userType == 2) {
                    const portalURL = this.router.url;
                    if (portalURL == '/student360/notificationPreferences' && !this.studentService.selectedStudent.PrimaryContact) {
                        this.logAccessDeniedInfo();
                        this.portalAccessDeniedDialog = this.dialog.open(PortalAccessDeniedComponent, {
                            panelClass: 'tyl-mat-dialog',
                            disableClose: true
                        });
                        this.portalAccessDeniedDialog.componentInstance.portalName = 'Notification Preferences';
                        this.router.navigateByUrl('/student360/studentSummary');
                    }
                }
            }
        });

        this.setSchoolDisabledSubscription = this.yearService.observableSetSchoolDisabledStream$.subscribe(disabled => {
            this.showSchoolDropdown = !disabled;
        });

        this.setYearDisabledSubscription = this.yearService.observableSetYearDisabledStream$.subscribe(disabled => {
            this.disableYearDropdown = disabled;
        });

        this.loginSettingSubscription = this.loginService.observableIntegrateWithTylerUStream$.subscribe(EnableTylerU => {
            this.IntegrateWithTylerU = EnableTylerU;
        });
    }


    logAccessDeniedInfo() {
        const messageObject: any = {};
        messageObject.url = this.router.url;
        messageObject.previousPortal = this.sharedService.previousPortal;
        messageObject.userType = this.userService.userType;
        messageObject.isV10 = this.LoginSettings.V10;
        messageObject.selectedStudent = this.studentService.selectedStudent;
        messageObject.allParentPortals = this.student360Service.allParentPortals;
        const systemLog = new SystemLog();
        systemLog.UserID = this.userService.currentUser.Id;
        systemLog.Timestamp = new Date();
        systemLog.InstanceName = window.location.href;
        systemLog.ProgramName = 'AccessDeniedPopup';
        systemLog.Type = 'Info';
        systemLog.MachineName = '';
        systemLog.StackTrace = '';
        systemLog.Context = '';
        systemLog.Message = JSON.stringify(messageObject);

        this.sharedService.createSystemLog(systemLog).pipe(take(1)).subscribe();
    }

    showMenuButton() {
        return this.userService.userType.toString() == '1' || !this.router.url.includes('studentSummary');
    }

    yearSelected(year: Year) {
        if (this.currentUser.UserType == 1) {
            const selectedYear = this.yearService.allYears.filter(o => o.Id == year.Id && o.SchoolID == this.selectedSchoolId)[0];
            if (selectedYear != null) {
                year = selectedYear;
            }
        }
        this.yearService.updateSelectedYear(year);
        this.studentService.clearRecentStudents();
        this.studentSearchService.resetSearchCriteria();

        this.selectedYear = this.years.filter(o => o.Id == this.yearService.defaultYear.Id)[0];
        this.selectedSchoolId = this.yearService.defaultYear.SchoolID;
        this.getSelectedSchoolYearStatus();
    }

    schoolSelected(schoolId: number) {
        this.schoolId = schoolId;
        this.yearService.updateSelectedSchool(schoolId);
        this.studentService.clearRecentStudents();
        this.studentSearchService.resetSearchCriteria();

        this.selectedYear = this.years.filter(o => o.Id == this.yearService.defaultYear.Id)[0];
        this.selectedSchoolId = this.yearService.defaultYear.SchoolID;
        this.getSelectedSchoolYearStatus();
    }

    getUserName() {
        return (this.userService.currentUser != undefined) ? this.userService.currentUser.FirstName + ' ' + this.userService.currentUser.LastName : '';
    }

    logoutUser() {
        if (this.loginService.LoginSettings.UseTID && this.loginService.hasSignedIntoTylerId) {
            this.authService.logout();
        }
        if (this.userService.googleUser && this.userService.googleUser.access_token) {
            google.accounts.oauth2.revoke(this.userService.googleUser.access_token);
        }
        if (this.userLoginFromLegacy == true && this.stopImpersonating == false) {
            window.close();
        }
        else if (this.stopImpersonating == true) {
            this.stopImpersonateClick();
        }
        else {
            this.router.navigateByUrl('/logout');
        }
    }

    setNotificationPreferencesClick() {
        this.router.navigateByUrl('/student360/setNotificationPreferences');
    }

    changeEmailAddressClick() {
        // POST: opens change Email dialog
        this.changeEmailDialogRef = this.dialog.open(ChangeEmailComponent, {
            minHeight: 325,
            minWidth: 400,
            disableClose: true
        });
    }

    changePasswordClick() {
        // POST: opens change password dialog
        this.ChangePasswordDialogRef = this.dialog.open(ChangePasswordComponent, {
            panelClass: 'tyl-mat-dialog',
            disableClose: true,
            minWidth: 400,
            minHeight: 270
        });
    }

    expandGroup($event: any, portalMenu: PortalMenuItem) {
        $event.stopPropagation();
        portalMenu.Expanded = portalMenu.Expanded == 1 ? 0 : 1;
    }

    menuPortalClick(staffPortal: Portal) {
        this.selectedStudent = this.studentService.selectedStudent;
        if ((!this.selectedStudent || !this.selectedStudent.Id || this.selectedStudent.Id <= 0)
            && staffPortal.PortalName == 'Academic History') {
            this.studentSearchClick(staffPortal);
        } else if (staffPortal.PortalName == 'Roster Query') {
            this.dataQueryService.rosterQuery = true;
            if (!this.classroomSummaryService.selectedCourse) {
                const dialogBox = this.dialog.open(SelectCourseDialogComponent, {
                    disableClose: true,
                    hasBackdrop: false,
                    panelClass: 'tyl-mat-dialog'
                });
                const subscription = dialogBox.afterClosed().subscribe(course => {
                    subscription.unsubscribe();
                    if (course) {
                        this.classroomSummaryService.selectedCourse = course;
                        this.router.navigateByUrl(staffPortal.ParentModule + staffPortal.PortalDescription);
                    }
                });
            } else {
                this.router.navigateByUrl(staffPortal.ParentModule + staffPortal.PortalDescription);
            }
        } else {
            this.dataQueryService.rosterQuery = false;
            let portalDescription = staffPortal.PortalDescription;
            if (staffPortal.PortalDescription == '/gradebook') {
                portalDescription = portalDescription + '/V9';
                this.classroom360Service.gradebookPortalSelected = true;
            } else if (staffPortal.PortalDescription == '/classroomAttendance') {
                this.classroom360Service.attendancePortalSelected = true;
            } else if (staffPortal.PortalDescription == '/classInformation' || staffPortal.PortalDescription == '/classAnnouncements') {
                this.classroom360Service.courseInfoPortalSelected = true;
            }
            this.router.navigateByUrl(staffPortal.ParentModule + portalDescription);
        }
    }

    studentMenuPortalClick(portal: Portal) {
        this.selectedStudent = this.studentService.selectedStudent;
        if (this.selectedStudent != null && this.selectedStudent.Id != null && this.selectedStudent.Id > 0) {
            this.router.navigateByUrl('/student360' + portal.PortalDescription);
        } else {
            portal.ParentModule = '/student360';
            this.studentSearchClick(portal);
        }
    }

    addFavoriteClick() {
        // POST: Add the current page to favorites and save

        // Obtaining all matching portals
        const url = this.router.url;
        let newFavPortal: Portal;
        let newFavPortals: Portal[] = this.staffAssignedPortals.filter(portal =>
            (portal.ParentModule + portal.PortalDescription).split('?')[0].trim().toLowerCase() == url.split('?')[0].toLowerCase()
        );

        // Edge case for Student Summary because the portal description is /home
        if (newFavPortals.length == 0 && url.toLowerCase().includes('/studentsummary')) {
            newFavPortals = this.staffAssignedPortals.filter(portal =>
                url.includes(portal.ParentModule) &&
                portal.PortalName == 'Student Summary'
            );
        }

        // Setting the new favorite portal
        if (newFavPortals && newFavPortals.length == 1) {
            newFavPortal = newFavPortals[0];
        } else {

            // We need to ensure we're getting the right group
            // NOTE: some staff pages have a "duplicate" student group page
            const route = this.router.parseUrl(this.router.url);
            if (route.queryParams['studentPortal'] && route.queryParams['studentPortal'].toString() == 'true') {
                newFavPortal = newFavPortals.find(portal => portal.GroupName.includes('Students'));
            } else {
                newFavPortal = newFavPortals.find(portal => !portal.GroupName.includes('Students'));
            }
        }

        // Saving the favorite
        if (newFavPortal) {

            // Updating the favorites
            const favExists: boolean = this.userPreferencesService.favoritesPreferences.FavoritePortals.filter(favPortal =>
                favPortal.Id == newFavPortal.Id
                || ((favPortal.Id == null || favPortal.Id == 0)
                    && favPortal.GroupName == newFavPortal.GroupName
                    && favPortal.PortalDescription == newFavPortal.PortalDescription.split('?')[0]
                    && favPortal.PortalModule == newFavPortal.ParentModule)).length != 0;
            if (!favExists) {

                // Create the favorite object
                const newFav: FavoritePortal = {
                    ParentPortalName: '',
                    PortalDescription: newFavPortal.PortalDescription.split('?')[0],
                    PortalName: newFavPortal.PortalName,
                    PortalModule: newFavPortal.ParentModule,
                    GroupName: newFavPortal.GroupName,
                    Id: newFavPortal.Id,
                    IsGroup: false,
                    Expanded: false
                };

                // Saving that object
                if (this.userPreferencesService.favoritesPreferences.FavoritePortals.indexOf(newFav) == -1) {
                    this.userPreferencesService.favoritesPreferences.FavoritePortals.push(newFav);
                    const xmlStream: string[] = [];
                    const prefs: FavoritePreferences = {
                        FavoritePortals: this.userPreferencesService.favoritesPreferences.FavoritePortals
                    };
                    xmlStream.push(JSON.stringify(prefs));
                    this.userPreferencesService.saveUserPreferences(
                        0,
                        '/OneSISFavorites',
                        xmlStream,
                        0,
                        '',
                        false
                    ).subscribe(
                        () => {
                            newFavPortal.Selected = true;
                            this.userPreferencesService.favoritesPreferences = prefs;
                        },
                        err => {
                            console.log(err);
                        }, () => {
                        }
                    );
                }
            }
        }
    }

    editFavoriteClick() {
        // POST: opens Edit Favorites dialog
        this.favoritesDialogRef = this.dialog.open(
            FavoritesModalComponent,
            {
                data: {
                    editFavorites: true,
                    staffAssignedPortals: this.staffAssignedPortals
                },
                width: '30%',
                height: '80%',
                maxHeight: '80vh',
                maxWidth: '30vw',
                disableClose: true
            }
        );
    }

    linksClick() {
        // POST: Get the links from the user service
        const links = _.cloneDeep(this.userService.userLinks());
        const tileLinks = _.cloneDeep(this.parentPortalsDeepCopy.filter(p => p.IsMyLinksTile == true));
        // if parent or student remove links that are also portals (tiles)
        // Links display in the link menu, tiles display in the Links Card
        /* if (this.userService.userType !== 1) {
            // Filter out duplicate links based on Id
            for (let i = links.length - 1; i >= 0; i--) {
                const refLink = tileLinks.filter(link => link.Id == links[i].Link_ID);
                if (refLink.length > 0) {
                    links.splice(i, 1);
                }
            }
        } */
        if (links != undefined) {
            this.districtLinks = links.filter(link => link.IsDistrictLevel == 'Yes');
            this.districtLinks.sort(function (a, b) {
                const textA = a.LinkName.toUpperCase();
                const textB = b.LinkName.toUpperCase();
                return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
            });
            this.myLinks = links.filter(link => link.IsDistrictLevel == 'No');
        }
    }

    linkSelected(link) {
        let webAddress = '';
        if (link.LinkUrl.toLowerCase().indexOf('http://') == 0) {
            webAddress = link.LinkUrl.substring(7);
        } else if (link.LinkUrl.toLowerCase().indexOf('https://') == 0) {
            webAddress = link.LinkUrl.substring(8);
        } else {
            webAddress = link.LinkUrl;
        }
        if (link.OpenAsHTTPS == true) {
            webAddress = 'https://' + webAddress;
        } else {
            webAddress = 'http://' + webAddress;
        }
        window.open(webAddress, '_blank');
    }

    editLinkClick() {
        // POST: navigates to links page
        this.router.navigateByUrl('/classroom360/links');
    }

    addLinkClick() {
        // POST: Opens add Link modal
        this.addLinkDialogRef = this.dialog.open(AddLinkComponent, {
            minWidth: 400,
            maxWidth: 400,
            minHeight: 300,
            disableClose: true
        });
    }

    studentSearchClick(portal: Portal) {
        // POST: opens change Student Search dialog
        const redirectUrl = portal ? portal.ParentModule + portal.PortalDescription : this.router.url && (this.router.url.indexOf('?studentPortal=true') > 0 || this.router.url.indexOf('manageBehaviorReferrals') > 0 || this.router.url.indexOf('behaviorReferral') > 0 || this.router.url.indexOf('communicationLog') > 0 || this.router.url.indexOf('attendanceByStudent') > 0 || this.router.url.indexOf('studentNotes') > 0 || this.router.url.indexOf('/schedule?selectedView=1') > 0 || this.router.url.indexOf('/student360') >= 0 || this.router.url.indexOf('academicHistory') > 0 || this.router.url.indexOf('studentEnrollment') > 0 || this.router.url.indexOf('studentHealth') > 0 || this.router.url.indexOf('programAndServices/singleStudent') > 0 || this.router.url.indexOf('householdInformation') > 0) ? this.router.url : '';
        let allowedSchools: School[];
        this.StudentSearchDialogRef = this.dialog.open(
            StudentSearchComponent,
            {
                data: {
                    performRoute: true,
                    searchAndSelect: false,
                    redirectUrl: redirectUrl,
                    schools: allowedSchools
                },
                width: '100%',
                height: '100%',
                maxHeight: '100vh',
                maxWidth: '100vw'
            }
        );
    }

    studentInFocusClick() {
        if (this.studentInFocus()) {
            this.studentInFocusDialog = this.dialog.open(StudentInFocusComponent, {
                panelClass: 'tyl-mat-dialog',
                disableClose: true
            });
        }
    }

    studentInFocus() {
        return this.studentService.selectedStudent;
    }

    showLanguageLinks() {
        // POST: shows the languages available to the user
        this.languageLinkVisible = true;
    }

    showUserLinks() {
        // POST: shows the default user menu
        this.languageLinkVisible = false;
    }

    languageClick(language: string) {
        // POST: selects a language
        this.userService.setUserLanguage(language).subscribe();
    }

    openReportsWindow() {
        this.reportingFrameworkService.checkDefaultLandingPage().subscribe(isMyReportPage => {
            if (this.LoginSettings.EnableMyReports == false || isMyReportPage == false) {
                this.reportsDialogRef = this.dialog.open(ReportingComponent, {
                    panelClass: 'tyl-mat-dialog',
                });
            } else {
                // POST: navigates to My Reports page
                this.myReportsDialogRef = this.dialog.open(MyReportsComponent, {
                    panelClass: 'tyl-mat-dialog',
                    minWidth: '100vw',
                    maxWidth: '100vw',
                    minHeight: '100vh',
                    maxHeight: '100vh'
                });
                this.myReportsDialogRef.componentInstance.showAsDialog = true;
            }
        });
    }

    userPreferencesClick() {
        const canContinue = this.guard.checkForDeactivation();
        if (canContinue instanceof Observable) {
            canContinue.subscribe(clickedOk => {
                if (clickedOk) {
                    this.preferencesClick();
                }
            });
        } else if (canContinue) {
            this.preferencesClick();
        }
    }

    preferencesClick() {
        let initialTab: string;

        switch (this.router.url) {
            case '/classroom360/cards':
                initialTab = 'Classroom Summary';
                break;
            case '/classroom360/classroomAttendance':
                initialTab = 'Attendance';
                break;
            case '/admin360/attendanceAdministration/attendanceByClass':
                initialTab = 'Attendance';
                break;
            case '/classroom360/communicationLog':
                initialTab = 'Communication Log';
                break;
            case '/classroom360/dataQuery':
                initialTab = 'Data Query';
                break;
            case '/classroom360/gradebook/V9':
                initialTab = 'Gradebook';
                break;
        }

        this.userPrefDialogRef = this.dialog.open(UserPreferencesWindowComponent, {
            width: '1400px',
            height: '810px',
            disableClose: true,
            data: {
                initialTab: initialTab
            },
        });
        this.userPrefDialogRef.componentInstance.staffAssignedPortals = this.staffAssignedPortals;
    }

    courseSelected(course: ClassroomSummary) {
        this.classroomSummaryService.selectedCourse = course;
    }

    courseCategory(category: string) {
        if (category == 'gradebook' && (this.router.url == '/classroom360/gradebook/V9')) {
            return true;
        } else if (category == 'attendance' && this.router.url == '/classroom360/classroomAttendance') {
            return true;
        } else if (category == 'general' && this.router.url != '/classroom360/gradebook/V10' && this.router.url != '/classroom360/classroomAttendance' && this.router.url != '/classroom360/gradebook/V9') {
            return true;
        } else {
            return false;
        }
    }

    getGradebookClasses() {
        this.gradebookClasses = this.myClasses.filter(o => o.UsedForGrading == true);
    }

    getAttendanceClasses() {
        this.attendanceClasses = this.myClasses.filter(o => o.AttendanceRequired == true && o.Enrolled > 0);
    }

    teacherProfileClick() {
        this.router.navigateByUrl('/classroom360/teacherProfile');
    }

    mealServiceClick() {
        this.router.navigateByUrl('/classroom360/staffMealService');
    }

    getPageInfo(url: string) {
        if (url.includes('?')) {
            url = url.substring(0, url.indexOf('?'));
        }
        const pageInfo = RouteInfo.pages.filter(function (page) {
            return page.Url == url;
        })[0];

        if (pageInfo) {
            this.showSchoolDropdown = pageInfo.ShowSchoolDropdown;
            if (pageInfo.ShowYearDropdown) {
                if (typeof (pageInfo.ShowYearDropdown) == 'boolean') {
                    this.showYearDropdown = pageInfo.ShowYearDropdown;
                } else {
                    this.showYearDropdown = pageInfo.ShowYearDropdown(this.loginService.LoginSettings.V10, this.sharedService.currentUrl.includes('classroom360'));
                }
            } else {
                this.showYearDropdown = false;
            }
            this.enableClassDropdown = pageInfo.RequiredCourse;
            if (pageInfo.DisableYearDropdown) {
                if (typeof (pageInfo.DisableYearDropdown) == 'boolean') {
                    this.disableYearDropdown = pageInfo.DisableYearDropdown;
                } else {
                    this.disableYearDropdown = pageInfo.DisableYearDropdown(this.loginService.LoginSettings.V10, this.sharedService.currentUrl.includes('classroom360'));
                }
            } else {
                this.disableYearDropdown = false;
            }
            if (pageInfo.HidePrintButton) {
                if (typeof (pageInfo.HidePrintButton) == 'boolean') {
                    this.hidePrintButton = pageInfo.HidePrintButton;
                } else {
                    this.hidePrintButton = false;
                }
            } else {
                this.hidePrintButton = false;
            }
            if (this.currentUser.UserType == 1 && this.router.url.indexOf('/student360') > -1 && this.router.url.indexOf('/scheduleHistory/multipleStudent') < 0) {
                this.disableYearDropdown = true;
            }
            this.screenWidth = screen != null ? screen.width : 0;
            this.windowWidth = window != null ? window.innerWidth : 0;
        }
        else if (url.toLowerCase().indexOf('/student360') < 0) {
            this.showSchoolDropdown = true;
            this.showYearDropdown = true;
            this.disableYearDropdown = false;
        }
    }

    getUserPermission() {
        if (this.currentUser.ActiveDirectoryUser == true) {
            this.showChangePassword = false;
        } else if (this.currentUser.UserType == 3) {
            this.showChangePassword = this.LoginSettings.AllowStudentsToChangeTheirPassword;
        } else if (this.currentUser.UserType == 1) {
            if (this.LoginSettings.StaffUserUseADPassword == true || this.LoginSettings.ActivateGoogleAuthenticationForStaff == true) {
                this.showChangePassword = false;
            } else {
                if (this.securityService.userPermissions.filter(o => o.PermissionCode == 'GO_DNATCOP').length > 0) {
                    this.showChangePassword = false;
                }
            }
        }
    }

    helpClick() {
        window.open('./assets/Help/Student%20360%20Help.pdf', '_blank');
    }

    getUserLoginFromLegacy() {
        this.stopImpersonating = false;
        this.impersonateByUserId = 0;
        if (sessionStorage.getItem('loginFromLegacy') != null && sessionStorage.getItem('loginFromLegacy') == '1') {
            this.userLoginFromLegacy = true;
            this.userService.getImpersonateByUser().subscribe((results) => {
                this.impersonateByUserId = results;
                if (this.impersonateByUserId > 0 && this.currentUser.UserType == 1 && sessionStorage.getItem('ClassicLoginAttempt') == null) {
                    // this.stopImpersonating = true;
                }
                if (this.impersonateByUserId == 0 && this.currentUser.UserType == 1 && sessionStorage.getItem('impersonateUseraccessToken') != null && sessionStorage.getItem('ClassicLoginAttempt') == null) {
                    this.userLoginFromLegacy = false;
                    sessionStorage.removeItem('loginFromLegacy');
                }
            });

        }
    }

    getPulseList() {
        if (this.LoginSettings.PulseURL != null && this.LoginSettings.PulseURL.length > 0) {
            const pulsePageList = [];
            const pulseFavoriteList = [];
            this.sharedService.createPulseKey('${getpagelist}', '', false).subscribe((results) => {
                const pulseKey = results;
                let pulseUrl = (this.LoginSettings.PulseURL.slice(-1) == '/') ? this.LoginSettings.PulseURL + 'pulserouter.aspx?pulseloginkey=' : this.LoginSettings.PulseURL + '/pulserouter.aspx?pulseloginkey=';
                pulseUrl = pulseUrl + pulseKey;
                $.getJSON(pulseUrl, (json) => {
                    const staticPulsePages = json.PulsePages;
                    const favoritePulsePages = json.FavoritePages;
                    if (staticPulsePages != undefined) {
                        const staticPages = Object.keys(staticPulsePages).map(e => staticPulsePages[e]);
                        for (const page of staticPages) {
                            pulsePageList.push(page);
                        }
                        this.pulsePageList = pulsePageList;
                    }
                    if (favoritePulsePages != undefined) {
                        const favoritePages = Object.keys(favoritePulsePages).map(e => favoritePulsePages[e]);
                        for (const page of favoritePages) {
                            pulseFavoriteList.push(page);
                        }
                        this.pulseFavoriteList = pulseFavoriteList;
                    }
                });
            });
        }
    }

    pulseLinkClick(page: string) {
        const createPKey = (pulseWindow) => {
            this.sharedService.createPulseKey(page, '', false).subscribe((results) => {
                const pulseKey = results;
                let pulseUrl = (this.LoginSettings.PulseURL.slice(-1) == '/') ? this.LoginSettings.PulseURL + 'pulserouter.aspx?pulseloginkey=' : this.LoginSettings.PulseURL + '/pulserouter.aspx?pulseloginkey=';
                pulseUrl = pulseUrl + pulseKey;
                pulseWindow.location = pulseUrl;
            });
        };

        if (this.pulseWindow != null) {
            if (!this.pulseWindow.closed) {
                this.pulseWindow.focus();
                createPKey(this.pulseWindow);
                return;
            }
        }
        this.pulseWindow = window.open('', '_blank');
        createPKey(this.pulseWindow);
    }

    showFavorites(event) {
        this.favoritesShown = true;
    }

    printClick() {
        // const pagePrintStyle: string = RouteInfo.getPagePrintStyle(this.router.url);
        if (this.router.url.indexOf('classroom360/seatingChart') > 0) {
            const pagePrintStyle: string = RouteInfo.getPagePrintStyle(this.router.url);
            const styleURLs: string[] = ['./assets/styles/print-styles.css'];
            if (pagePrintStyle) {
                styleURLs.push(pagePrintStyle);
            }
            this.spinnerService.showSpinner = true;
            // Timeout is needed to allow the spinner to show before the print preview load takes priority
            setTimeout(() => {
                printJS({
                    printable: 'print-content',
                    documentTitle: 'OneSIS',
                    type: 'html',
                    css: styleURLs,
                    ignoreElements: ['print-ignore'],
                    targetStyles: ['*'],
                    maxWidth: 1500
                });
                this.spinnerService.showSpinner = false;
            }, 500);
        } else {
            // Timeout is needed to allow the spinner to show before the print preview load takes priority
            setTimeout(() => {
                this.sharedService.pageToPdfTrigger = !this.sharedService.pageToPdfTrigger;
            }, 0);
        }

    }

    aboutTylerSISClick() {
        this.aboutTylerSISDialog = this.dialog.open(AboutPanelComponent, {
            panelClass: 'tyl-mat-dialog',
            width: '600px',
            disableClose: true
        });
    }

    documentationClick() {
        let url = '';
        if (this.router.url.indexOf('gradebook') == -1) {
            url = this.router.url.substr(this.router.url.lastIndexOf('/'));
        } else {
            url = '/classroomgradebook';
        }
        this.helpContextId = url + '_' + this.LoginSettings.OneSISVersion + '_';
        this.helpContextId = this.helpContextId + 'V9';
        const helpButton = $('#buttonHelp')[0];
        setTimeout(() => {
            helpButton.click();
        }, 0);
    }

    homeClick() {
        if (this.currentUser.UserType == 1 && this.LoginSettings.ActivateClassroom360 && this.userLoginFromLegacy == false) {
            if (this.studentService.selectedStudent) {
                this.getUserYears();
            }
            this.router.navigateByUrl('/classroom360/cards');
        } else if (this.currentUser.UserType == 1 && this.userLoginFromLegacy == true) {
            if (this.studentService.selectedStudent) {
                this.getUserYears();
            }
            this.router.navigateByUrl('/classroom360/cards');
        } else {
            this.router.navigateByUrl('/student360/studentSummary');
        }
    }

    getUserYears() {
        this.yearService.getUserYears(this.userService.currentUser.Id, this.userService.currentUser.UserType, this.userService.studentId).subscribe(years => {
            this.yearService.loadYears(years);
            this.yearService.years = years;
            let school = this.yearService.defaultYear.SchoolID == 0 ? this.schoolId : this.yearService.defaultYear.SchoolID;
            school = school == 0 ? this.userService.currentUser.LoginSchoolId : school;
            this.years = _.cloneDeep(years.filter(year => year.SchoolID == school));
            this.schools = _.sortBy(this.yearService.schools, ['SchoolCode', 'SchoolName']);
            if (this.yearService.defaultYear) {
                this.selectedYear = this.years.filter(o => o.Id == this.yearService.defaultYear.Id)[0];
                this.selectedSchoolId = school;
                this.getSelectedSchoolYearStatus();
            }
        });
    }

    getSelectedSchoolYearStatus() {
        if (this.userService.currentUser.UserType == 1 && this.yearService.allYears && this.selectedSchoolId) {
            this.yearService.allYears.filter(o => o.SchoolID == this.selectedSchoolId).forEach(obj => {
                const year = this.years.filter(o => o.Id == obj.Id)[0];
                if (year) {
                    year.Status = obj.Status;
                    year.IsOverride = obj.IsOverride;
                }
            });
        }
    }

    addEditLinkPrivilege(): boolean {
        if (this.currentUser.UserType == 1) {
            return true;
        }
        else {
            return false;
        }
    }

    @HostListener('window:resize', ['$event'])
    onResize() {
        this.windowWidth = window != null ? window.innerWidth : 0;
    }

    // switch back to impersonate
    stopImpersonateClick() {
        sessionStorage.removeItem('accessToken');
        sessionStorage.removeItem('loginFromLegacy');
        if (this.impersonateByUserId > 0 && this.currentUser.UserType == 1 && sessionStorage.getItem('impersonateUseraccessToken') != null) {
            this.redirectTo360(System.baseUrl + 'login', sessionStorage.getItem('impersonateUseraccessToken'), 'StudentId:0');
        }
    }

    redirectTo360(tylerSisUrl, accessToken, action) {
        if (accessToken != '') {
            try { action = window.btoa(action); } catch (e) { }
            const url: any = tylerSisUrl + '?Action=' + action;
            const win = window.open(url, '_self');
            win.sessionStorage.setItem('accessToken', accessToken);

        }
        else {
            console.log('fn_RedirectFail');
        }
    }

    TylerUClick() {
        this.sharedService.getTylerUToken(this.userService.currentUser.UserIsTeacher).subscribe(result => {
            const tylerUData = result;
            if (tylerUData.tylerUSetttingError == '') {
                window.localStorage.setItem('TylerUData', JSON.stringify(tylerUData));
                window.open(System.baseUrl + 'tylerU', '_blank');
            } else {
                this.TylerUSettingDialog = this.dialog.open(GeneralConfirmationComponent, {
                    panelClass: 'tyl-mat-dialog',
                    disableClose: true
                });
                this.TylerUSettingDialog.componentInstance.disableConfirmation = true;
                this.TylerUSettingDialog.componentInstance.headerLabel = 'Tyler U';
                this.TylerUSettingDialog.componentInstance.informational = true;
                this.TylerUSettingDialog.componentInstance.confirmMessage = tylerUData.tylerUSetttingError;
                return;
            }
        });
    }

    currentURL() {
        return this.router.url;
    }
}
